import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-invited-users',
  templateUrl: './invited-users.component.html',
  styleUrls: ['./invited-users.component.css']
})
export class InvitedUsersComponent implements OnInit {

  constructor(
    private route: ActivatedRoute
    , private router: Router
    , private cookieService: CookieService
    , private spinner: NgxSpinnerService) {
      spinner.show();
     }

  ngOnInit() {
    sessionStorage.removeItem('token');
    this.route.queryParamMap.subscribe(paramsdata => {
      const token = paramsdata['params']['id'];
      const invitedToken = paramsdata['params']['invite-token'];
      if (token && invitedToken) {
        this.cookieService.set('token', invitedToken, 0, '/',
          null,
          null, 'Lax');
        this.router.navigate(['/register/user-business'], { queryParams: { id: token } });
        this.spinner.hide();
      } else {
         this.cookieService.deleteAll('/');
        this.router.navigate(['/']);
        this.spinner.hide();
      }
    });
  }

}
